import React, {useEffect, useRef, useState} from 'react';
import {useAppDispatch, useAppSelector} from "../redux";

import {useNavigate} from "react-router-dom";

import './MyFilters.scss'

import TableFilters from "../components/table-filters";
export default function MyFilters() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    return (
        <div className="my-filters-wrapper">
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h1 className="text-base font-semibold leading-6 text-gray-900">My Filters</h1>
                    </div>
                    <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                        <button
                            type="button"
                            className="block rounded-md px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            onClick={() => navigate('/my-filters/new')}
                        >
                            Add
                        </button>
                    </div>
                </div>
                <div className="mt-4 flow-root bg-white card-shadow">
                    <TableFilters/>
                </div>
            </div>

            {/*<Filter/>*/}
        </div>
    );
}
